export const camelCaseToSnakeCase = (str :string) :string => {
  return str.replace(/[A-Z]/g, (letter :string) => `_${letter.toLowerCase()}`);
};

/**
 * Convert keys of single object, from camelCase to snake_case.
 * It doesn't convert key names with number next to underscore. Ex. 'logistic1' to 'logistic_1'.
 * It doesn't convert nested objects.
 */
export const camelCaseToSnakeCaseObjectKeys = (
  obj :Record<string, any>,
) :Record<string, any> =>
  Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [camelCaseToSnakeCase(key), value]),
  );

export function toCapitalize(value :string, everyWord :boolean = false) :string {
  if (!value) {
    return value;
  }

  return everyWord
    ? value.replace(/\b\w/g, (l) => l.toLocaleUpperCase()) // cap every word
    : value.charAt(0).toUpperCase() + value.slice(1); // cap first char only
}

export const snakeCaseToTitleCase = (str :string) :string => {
  return str
    .split('_')
    .map((word) => toCapitalize(word, true))
    .join(' ');
};

export const toCamelCase = (str :string) :string => {
  return str
    .toLowerCase()
    .split(' ')
    .map((word, index) =>
      index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1),
    )
    .join('');
};

export function toSnakeCaseWithNumberSuffix(
  text :string,
  value :number = 0,
) :string {
  return `${text.trim().toLowerCase().replace(/\s+/g, '_')}_${value}`;
}

/**
 * Converts a snake_case string to camelCase.
 * @param str - The snake_case string to convert.
 * @returns The camelCase string.
 */
export const snakeToCamel = (str :string) :string => {
  return str.replace(/(_\w)/g, (match) => match[1].toUpperCase());
};
